import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, AdScreen } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class AdScreenService {
  constructor(private apiService: ApiService) {
    this.getUserPath();
  }

  getUserPath() {
    this.apiService.getUserPath();
  }

  list(): Observable<DataList<AdScreen>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<AdScreen>>(`${this.apiService.userPath}ad_screens`).pipe();
  }
}
